import { EMPTY_LIST } from '../../../../constants/common'
import { ChatTableRow } from '../../../Chat'
import { Container } from '../../Container'
import { getTableRowData, TABLE_ROW_VISIBLE_COLUMNS } from '../Chats.mock'

function ChatsTableRow() {
  return (
    <>
      <Container label='Chat table row, without actions, all columns, unread'>
        <ChatTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData()}
          selected={EMPTY_LIST}
        />
      </Container>
      <Container label='Chat table row, without actions, all columns'>
        <ChatTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData({ unread_messages_count: 0 })}
          selected={EMPTY_LIST}
        />
      </Container>
    </>
  )
}

export default ChatsTableRow
